import functions from './functions.js';
import listResults from './list/listResults.js';
import pagination from './list/pagination.js';
import Slider from "./Slider";
import { listMap } from "./list-map.js";

$(() => {
    list.init();
});

const list = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        personsInObject: 1,
        _page: 1,
        perPage: 12,
        language: functions.getLang(),
        pool: '',
        parking: '',
        pets: '',
        internet: '',
        dateFrom: '',
        dateTo: '',
        dates: null,
        destination: '',
        objectTypeId: '',
        guests: '',
        hasArrival: 4,
        categoryObjectExact: 1,
        countryId: null,
        regionId: null,
        rivieraId: null,
        placeId: null,
        objectName: null, 
        tagCategoryId: null,
        linkedId: null,
    },
    params: {},
    isHome: false,
    $listItems: null,
    filterParams: {
        tagCategoryId: null,
        categoryObject: null, 
        categoryUnits: null,
        sortBy: null, 
        objectName: null, 
        distanceBeach: null, 
        distanceCenter: null, 
        pool: null, 
        parking: null, 
        pets: null, 
        internet: null, 
        unitServiceIds: null, 
    },
    mainFields: ['dateFrom', 'dateTo', 'destination', 'objectTypeId', 'persons', 'personsInObject', 'sortBy', '_page'],
    init() {

        list.$form = $('.search-form');
        list.form = list.$form[0];

        list.$filter = $('.search-filter');
        list.filter = list.$filter[0];  

        if(! list.form) {

            if ($('[id^=list-slider]')[0]) {
                let listSlider = [];
                $('[id^=list-slider]').each((i, elem) => {
                    const length = $(elem).find('.keen-slider__slide').length;
                    listSlider[i] = new Slider('#' + $(elem).attr('id'), {
                        rubberband: false,
                        loop: true,
                        arrows: true,
                        slidesPerView: 1,
                        spacing: 0,
                        pager: false
                    });
                });
            }

            return;
        }

        list.isHome = list.$form.attr('data-ishome');
        list.defaults.objectGroupId = list.$form.attr('data-objectgroupid') || '';
        list.defaults.objectTypeId = list.$form.attr('data-objecttypeid') || '';
        list.defaults.destination = list.$form.attr('data-destination') || '';
        list.defaults.countryId = list.$form.attr('data-countryId') || '';
        list.defaults.linkedTypeId = list.$form.attr('data-linkedtypeid') || '';
        list.filterParams.tagCategoryId = list.defaults.tagCategoryId = list.$form.attr('data-tagcategoryid') || '';
        list.defaults.withoutPartner = list.$form.attr('data-withoutpartner') || '';

        if(list.defaults.withoutPartner) list.params.partnerId = null;

        list.$form.on('submit', e => {
            const $target = $(e.target);
            e.preventDefault();

            list.params = $.extend({}, list.defaults, functions.getFormData($target));
            if(list.defaults.objectGroupId == 6 && ! list.isHome) {
                list.filterParams.objectName = list.params.objectName ? list.params.objectName : null;
            }
            if( ! list.isHome) {
                list.params = $.extend(list.params, list.filterParams, functions.getFormData(list.$filter));
            }
            list.params._page = list.defaults._page;

            if(list.isHome) {
                list.params.objectGroupId = list.defaults.objectGroupId = $(e.target).attr('data-objectgroupid');
                list.params = functions.cleanParams(list.params, this.defaults);
                location = $('[data-listurl][data-objectgroupid=' + list.defaults.objectGroupId + ']').attr('data-listurl') + '#' + $.param(list.params);
            } else {
                functions.setUrlData(list.params, true, list.defaults);
            }

        });

        if(list.isHome) {
            functions.setFormData(list.form, list.defaults);
            return;
        }

        list.$listItems = $('.list-items');

        if(! list.isHome) {
            //list.initComponents();

            list.getParams();
            functions.setFormData(list.form, list.params);
            if(list.filter) {
                functions.setFormData(list.filter, list.params);
            }
            list.splitCalendarDates($('[name=dates]').val());
            list.params.guests = $('[name=guests]').val();
            list.find();
        } else {
            functions.setFormData(list.form, list.params);
        }

        $('#listMapModal').on('shown.bs.modal', e => {
            if ( e.target.id == 'listMapModal' ) {
                //list.initComponents();
                loadGoogleMaps().done(() => {
                    if( $('.list-map') ) {
                        if ( !listMap.$map ) {
                            listMap.init();
                        }                   
                        listMap.mapFind(list.params);
                    }
                });
            }   
        });

        list.$filter.on('change', e => {
            const $target = $(e.currentTarget);
            e.preventDefault();

            if ( list.stopChangeEvents ) {
                return;
            }
            
            list.params = $.extend(list.params, list.filterParams, functions.getFormData($target));
            list.params._page = list.defaults._page;
            functions.setUrlData(list.params, true, list.defaults);
        });

        list.$filter.on('submit', e => {
            e.preventDefault();
        });

        $('.btn-clear-filters').on('click', e => {
            e.preventDefault();
            list.params = $.extend(list.params, list.filterParams);
            list.params._page = list.defaults._page;
            functions.setUrlData(list.params, true, list.defaults);
        });

        if(list.defaults.objectGroupId == 6) {
            $('[name="tagCategoryId"]').on('change', e => {
                list.getParams();
                //list.params._page = list.defaults._page;
                list.setTagCategoryId();
                list.params = $.extend(list.params, {_page: list.defaults._page, tagCategoryId: list.params.tagCategoryId});
                functions.setUrlData(list.params, true, list.defaults);
                //list.find();
            });
            list.setFormTags();
        }

        $('.cruises-tags-slider .keen-slider__slide').on('click', e => {
            const $target = $(e.currentTarget);
            list.getParams();
            list.params.tagCategoryId = $target.attr('data-tagcategoryid');
            list.params = $.extend(list.params, {_page: list.defaults._page, tagCategoryId: list.params.tagCategoryId});
            functions.setUrlData(list.params, true, list.defaults);
        });

        $(window).on('hashchange', e => {
            if(list.params.objectGroupId == 6) {
                list.setFormTags();
            }
            list.getParams();
            if(list.params.objectGroupId == 6) {
                list.setTagCategoryId();
                list.setFormTags();
            }
            list.stopChangeEvents = true;
            //functions.setFormData(list.form, list.params);
            if ( list.filter ) {               
                functions.setFormData(list.filter, list.params);
            }
            functions.scrollToElement(list.$listItems, 100);
            list.find();
            list.stopChangeEvents = false;
        });

        $('.guide-clear').toggleClass('d-none', ! list.params.destination);

        $('.guide-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            list.params.destination = '';
            $(e.currentTarget).parents('.form-guide-container').find('[name="destination"]').val('').trigger('change');
        });

        $('[name="destination"]').on('change', e => {
            $(e.currentTarget).parents('.form-guide-container').find('.guide-clear').toggleClass('d-none', ! $(e.currentTarget).val());
        });

    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            list.params.dateFrom = aDates[0] ? aDates[0] : null;
            list.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    setFormTags() {
        if(list.params.tagCategoryId) {
            let tagCategoryIds = list.params.tagCategoryId.split(',');
            $('[name="tagCategoryId"]').prop('checked', false);
            tagCategoryIds.forEach(tagCategoryId => {
                $('[name="tagCategoryId"][data-value="' + tagCategoryId + '"]').prop('checked', true);
            });
        }
    },
    setTagCategoryId() {
        if($('[name="tagCategoryId"]').length) {
            let tagCategoryIds = [];
            $('[name="tagCategoryId"]').each((index, target) => {
                const $target = $(target);
                if($target[0].checked) {
                    tagCategoryIds.push($target.attr('data-value'));
                }
            });
            list.params.tagCategoryId = tagCategoryIds.join(",");
        }
    },
    getParams() {      
        list.params = $.extend({}, list.defaults, list.filterParams, functions.getUrlData(true));
        if(list.params.dates) {
            let dates = list.params.dates.split(' - ');
            list.params.dateFrom = dates && dates[0] ? dates[0] : null;
            list.params.dateTo = dates && dates[1] ? dates[1] : null;
        }
        list.setDestination(list.params);
        list.params.categoryUnits = list.params.categoryObject ? list.params.categoryObject : null;
        list.params.categoryObject = list.params.categoryObject ? list.params.categoryObject : null;
    },
    setDestination(params) {

        const isSki = params.linkedTypeId && params.linkedTypeId == 32;
        let destination = params.destination;

        if(destination) {
            const destinations = destination.split(',');

            if(isSki) {
                let countryIds = [];
    
                destinations.forEach(destination => {
                    const dest = destination.split(':');
                    
                    list.params.countryId = dest[0] ? list.getDestinationIds(dest[0], countryIds) : list.defaults.countryId;
                    list.params.linkedId = dest[1] ? dest[1] : list.defaults.linkedId;
                });
                list.params.regionId = list.defaults.regionId;
            } else {
                let countryIds = [],
                    regionIds = [],
                    rivieraIds = [],
                    placeIds = [];
    
                destinations.forEach(destination => {
                    const dest = destination.split(':');
                    
                    list.params.countryId = dest[0] ? list.getDestinationIds(dest[0], countryIds) : list.defaults.countryId;
                    list.params.regionId = dest[1] ? list.getDestinationIds(dest[1], regionIds) : list.defaults.regionId;
                    list.params.rivieraId = dest[2] ? list.getDestinationIds(dest[2], rivieraIds) : list.defaults.rivieraId;
                    list.params.placeId = dest[3] ? list.getDestinationIds(dest[3], placeIds) : list.defaults.placeId;
                });
            }
        } else {
            list.params.countryId = list.defaults.countryId;
            list.params.regionId = list.defaults.regionId;
            list.params.rivieraId = list.defaults.rivieraId;
            list.params.placeId = list.defaults.placeId;
            list.params.linkedId = list.defaults.linkedId;
        }
    },
    getDestinationIds(destination, array) {
        if(destination && $.inArray(destination, array)) {
            array.push(destination);
        }
        return array.join();
    },
    find() {
        
        list.setLoadingMode();

        // show cruises up to 2 years in advance
        if(list.params.objectTypeId == 51 && ! list.params.arrivalDateFrom) {
            let today = new Date();
            today.setHours(0,0,0,0);
            
            let tomorrow = new Date(today.getTime());
            tomorrow.setDate(tomorrow.getDate() + 1);

            let arrivalDateTo = new Date(tomorrow.getTime());
            arrivalDateTo.setFullYear(arrivalDateTo.getFullYear() + 2);

            list.params.arrivalDateTo = arrivalDateTo.getFullYear() + '-' + (arrivalDateTo.getMonth() + 1) + '-' + arrivalDateTo.getDate();
        }

        list.params.sortBy = list.params.duration ? 6 : null;
        list.params.destination = list.params.linkedTypeId == 32 && list.params.destination.split(':').length == 2 ? null : list.params.destination;

        $.get('/services/list', list.params).then(response => {
            response = JSON.parse(response);          

            list.unsetLoadingMode();

            list.total = response.total;

            list.$listItems.html(response.html);
            if (list.total != 0) {

                $('.paginate').html(pagination({
                    currentPage: list.params._page,
                    total: list.total,
                    perPage: list.defaults.perPage,
                }));
            }

            // LOZAD
            window.observer.observe();

            listResults.getResults(list.total, list.params._page, list.defaults.perPage);

            list.initComponents();
        });

    },
    paginate(page) {
        if (page != list.params._page) {
            list.params._page = page;
        }

        functions.setUrlData(list.params, true, list.defaults);
    },
    setLoadingMode() {
        if(! list.loading) {
            list.loading = true;

            // form submit btn
            (list.$form).find('button').prop('disabled', true);

            if ( ! $('.spinner').length) {
                $('<div class="spinner d-none"><div class="spinner-border text-secondary" role="status" style="width: 4rem; height: 4rem;"><span class="sr-only">Loading...</span></div></div>').insertBefore('.list-items');
            }

            $('.spinner').removeClass('d-none');
            $('.spinner').addClass('d-flex justify-content-center');
            list.$listItems.addClass('d-none');
            $('.paginate').addClass('d-none');
        }
    },
    unsetLoadingMode() {
        if(list.loading) {
            list.loading = false;

            // form submit btn
            (list.$form).find('button').prop('disabled', false);

            $('.spinner').removeClass('d-flex justify-content-center');
            $('.spinner').addClass('d-none');
            list.$listItems.removeClass('d-none');
            $('.paginate').removeClass('d-none');

            //functions.scrollToElement(list.$listItems, 100);
        }
    },
    initComponents() {

        let priceValue = $('#priceRange').slider('getValue');
        
        if(priceValue){
            $('.priceFrom').text(priceValue[0] ? priceValue[0] : '0');
            $('.priceTo').text(priceValue[1] ? priceValue[1] : '-');
        }

        $('#priceRange').on('slideStart', e => { 
            list.stopChangeEvents = true;
        });
         $('#priceRange').on('slideStop', e => {
            list.stopChangeEvents = false;
            priceValue = $('#priceRange').slider('getValue');
            if(priceValue){
                $('.priceFrom').text(priceValue[0] ? priceValue[0] : '0');
                $('.priceTo').text(priceValue[1] ? priceValue[1] : '-');
            }
            $('#priceRange').slider('setValue', priceValue);
            list.params.priceRange = priceValue;
            list.params.priceFrom = priceValue[0] ? priceValue[0] : null;
            list.params.priceTo = priceValue[1] ? priceValue[1] : null;
            //functions.setUrlData(list.params, true);
            list.$filter.trigger('change');
        });

        /*$('#priceRange').on('slideStop', e => {
            list.params.priceRange = $(e.currentTarget).slider('getValue');
            list.params = $.extend(list.params, list.getParams(), functions.getFormData(list.$filter));
            list.params._page = list.defaults._page;

            functions.setUrlData(list.params, true);
        });*/

        let listSlider = [];
        $('[id^=list-slider]').each((i, elem) => {
            const length = $(elem).find('.keen-slider__slide').length;
            listSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
                slidesPerView: 1,
                spacing: 0,
                pager: false
            });
        });

        /*list.$sortBy = $('[name="sortBy"]');
        list.sortBy = list.$sortBy[0] ? list.$sortBy[0] : null;

        if(list.sortBy && list.params.sortBy) {
            list.$sortBy.val(list.params.sortBy);
        }

        list.$sortBy.on('change', e => {
            list.params = $.extend(list.params, list.getParams(), functions.getFormData(list.$sortBy));
            list.params._page = list.defaults._page;
            functions.setUrlData(list.params, true, true);
        });*/

        // register paginate        
        $('[data-page]').on('click', e => {
            e.preventDefault();
            list.paginate(+$(e.currentTarget).attr('data-page'));
        });

        /*$('[type=checkbox]').on('change', e => {
            list.params = $.extend(list.params, list.defaults, functions.getFormData(list.$filter));
            list.params._page = list.defaults._page;

            functions.setUrlData(list.params, true);
        });*/

        // Cancellation policy modal
        $('.btn-cp').on('click', e => {
            e.preventDefault();
            e.stopPropagation();

            const $target = $(e.currentTarget);
            
            let modalId = $target.attr('data-target');
            modalId = modalId.replace('#', '');

            const $modal = $('.modal[id=' + modalId + ']');
            $modal.modal('show');

        });

    },
}
